export class PeriodPreferenceModel {
    EngagementId: number;
    PeriodPreference: boolean;
    QueueIdentifier: number;
  }
